"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchInput = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var icons_1 = __importDefault(require("../../../assets/icons"));
var theme_1 = __importDefault(require("../../../styles/theme"));
var Icon_1 = require("../../atoms/Icon/Icon");
var Input_1 = require("../../atoms/Input/Input");
var SearchStatusIcons_1 = require("../SearchStatusIcons/SearchStatusIcons");
var SearchInput_style_1 = __importDefault(require("./SearchInput.style"));
/**
 * SearchInput molecule
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/molecules-searchinput--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/molecules/SearchInput Source}
 */
var SearchInput = function (_a) {
    var className = _a.className, placeholder = _a.placeholder, isSearchLoading = _a.isSearchLoading, searchText = _a.searchText, setSearchText = _a.setSearchText, searchError = _a.searchError, disabled = _a.disabled, _b = _a.fontVariant, fontVariant = _b === void 0 ? 'headline3' : _b;
    var classes = (0, SearchInput_style_1.default)();
    return ((0, jsx_runtime_1.jsx)(Input_1.Input, { className: (0, classnames_1.default)(classes.root, className), fontVariant: fontVariant, placeholder: placeholder, useDarkPlaceholder: true, value: searchText, onChange: function (event) { return setSearchText(event.target.value); }, startAdornment: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { iconPath: icons_1.default.search, color: theme_1.default.textColors.highlight, className: classes.startIcon }), disabled: disabled, endAdornment: (0, jsx_runtime_1.jsx)(SearchStatusIcons_1.SearchStatusIcons, { loading: !!isSearchLoading, searchInput: searchText, onClearInput: function () { return setSearchText(''); }, searchError: searchError, disabled: disabled }) }));
};
exports.SearchInput = SearchInput;
